<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <Dialog
            v-if="view_type === 'custom'"
            :value="menu_open"
            :header-text="$t('Custom recurrence')"
            :width="600"
            persistent
            fixed
            class="recurrence-menu"
            @close_modal="menu_open = false"
        >
            <template #activator="{ on }">
                <RecurrenceButton
                    :label="label"
                    :current-state="current_state"
                    :can-add-repeat="canAddRepeat"
                    :menu-open="menu_open"
                    :error-messages="errorMessages"
                    :on="on"
                    @add-repeat="addRepeat"
                />
            </template>
            <div
                v-if="form_data"
                class="px-2"
            >
                <div class="pt-0 pb-0">
                    <v-row class="mt-0">
                        <v-col
                            :class="[
                                'col-md-6 pr-4 pt-0 recurrence-field line-right',
                                { 'col-12': !$route.query.ukuwinversion }
                            ]"
                        >
                            <div class="fld-title">{{ $t("Start date") }}</div>
                            <div class="line"></div>
                            <v-row>
                                <v-col class="col-3 pr-1 pt-5 pb-1">{{ $t("Every") }}</v-col>
                                <v-col class="col-3 px-1 pb-1">
                                    <v-text-field
                                        v-model="form_data.interval_f"
                                        outlined
                                        class="task-form-elem pt-0"
                                        hide-details
                                        :error-messages="form_data.interval_error"
                                        @change="integer_field_changed('interval', $event)"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="col-6 pl-1 pb-1">
                                    <v-select
                                        v-model="form_data.type"
                                        :items="types"
                                        item-text="text"
                                        item-value="name"
                                        outlined
                                        class="task-form-elem pt-0 recurrence-type-field"
                                        hide-details
                                        @change="recurrence_changed"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row v-if="form_data.type == 'yearly'">
                                <v-col class="col-12 py-1">
                                    <v-select
                                        :value="form_data.month_of_year"
                                        :items="months_of_year"
                                        item-text="text"
                                        item-value="value"
                                        outlined
                                        class="task-form-elem pt-0"
                                        hide-details
                                        @change="onChangeYearlyMonthOfYear"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row v-if="form_data.type == 'quarterly'">
                                <v-col class="col-12 py-1">
                                    <v-select
                                        v-model="form_data.month_of_quarter"
                                        :items="months_of_quarter"
                                        item-text="text"
                                        item-value="value"
                                        outlined
                                        class="task-form-elem pt-0"
                                        hide-details
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row
                                v-if="
                                    form_data.type == 'yearly' ||
                                        form_data.type == 'monthly' ||
                                        form_data.type == 'quarterly'
                                "
                            >
                                <v-col class="col-12 py-1">
                                    <v-select
                                        v-model="form_data.day_of_month"
                                        :items="days_of_month"
                                        item-text="text"
                                        item-value="value"
                                        outlined
                                        class="task-form-elem pt-0"
                                        hide-details
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row v-if="form_data.type == 'weekly'">
                                <v-col class="col-12 py-1">
                                    <v-select
                                        v-model="form_data.weekdays"
                                        :items="days_of_week"
                                        multiple
                                        outlined
                                        class="task-form-elem pt-0"
                                        hide-details
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row
                                v-if="
                                    form_data.type == 'yearly' ||
                                        form_data.type == 'monthly' ||
                                        form_data.type == 'quarterly'
                                "
                            >
                                <v-col class="col-12 pt-3 pb-1">
                                    <v-select
                                        v-model="form_data.shift_to_workday"
                                        :label="$t('In case of holiday')"
                                        :items="shifting"
                                        item-text="text"
                                        item-value="value"
                                        outlined
                                        class="task-form-elem"
                                        hide-details
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row v-if="!show_start_time_field" class="px-3">
                                <v-col class="col-12 pa-0">
                                    <v-btn
                                        text
                                        small
                                        color="primary"
                                        style="text-transform: none;"
                                        @click="show_start_time_field = true"
                                    >
                                        + {{ $t("Set time") }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col class="col-12 pt-3 pb-1">
                                    <v-text-field
                                        v-model="form_data.time_f"
                                        outlined
                                        class="task-form-elem"
                                        :label="$t('Start time')"
                                        hide-details="auto"
                                        :error-messages="form_data.time_error"
                                        @change="time_field_changed('time', $event)"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="col-7">
                                    <v-menu
                                        v-model="date_menu_open"
                                        lazy
                                        offset-y
                                        :close-on-content-click="false"
                                        :nudge-top="18"
                                        min-width="280"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :label="$t('Repeat from') + ' *'"
                                                readonly
                                                :value="form_data.date | format_date"
                                                hide-details
                                                :error-messages="form_data.date_error"
                                                outlined
                                                class="task-form-elem"
                                                append-icon="mdi-calendar"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="form_data.date"
                                            min="1900-01-01"
                                            color="primary"
                                            no-title
                                            :locale="locale"
                                            :first-day-of-week="firstDayOfWeek"
                                            @input="date_menu_open = false; form_data.date_error = null "
                                        ></v-date-picker>
                                    </v-menu>
                                    <div v-if="task.recurrence_rule && task.date" class="caption n3--text">
                                        {{ $t('Previous repeat from: {0}').format(formatDate(parseSysDate(task.date))) }}
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col :class="['col-md-6 pr-4 pt-0 recurrence-field', { 'col-12': !$route.query.ukuwinversion }]">
                            <div class="fld-title">{{ $t("Due date") }}</div>
                            <div class="line"></div>
                            <v-row>
                                <v-col>
                                    <v-radio-group
                                        v-model="form_data.due_date_type"
                                        row
                                        class="mt-0 mb-2"
                                        hide-details
                                        @change="due_date_type_change"
                                    >
                                        <v-radio
                                            v-if="
                                                form_data.type === 'monthly' ||
                                                    form_data.type === 'quarterly' ||
                                                    form_data.type === 'yearly'
                                            "
                                            :label="$t('On date')"
                                            value="on_date"
                                        ></v-radio>
                                        <v-radio
                                            v-if="
                                                form_data.type === 'weekly' ||
                                                    form_data.type === 'monthly' ||
                                                    form_data.type === 'quarterly' ||
                                                    form_data.type === 'yearly'
                                            "
                                            :label="$t('Plus days')"
                                            value="plus_days"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <template v-if="form_data.due_date_type === 'on_date'">
                                <v-row v-if="form_data.type === 'yearly'">
                                    <v-col class="col-12 py-1">
                                        <v-select
                                            :value="form_data.due_month_of_year"
                                            :items="months_of_year"
                                            item-text="text"
                                            item-value="value"
                                            outlined
                                            class="task-form-elem pt-0"
                                            hide-details
                                            @change="onChangeYearlyDueMonthOfYear"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row v-if="form_data.type === 'quarterly'">
                                    <v-col class="col-12 py-1">
                                        <v-select
                                            v-model="form_data.due_month_of_quarter"
                                            :items="months_of_quarter"
                                            item-text="text"
                                            item-value="value"
                                            outlined
                                            class="task-form-elem pt-0"
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row
                                    v-if="
                                        form_data.type === 'yearly' ||
                                            form_data.type === 'monthly' ||
                                            form_data.type === 'quarterly'
                                    "
                                >
                                    <v-col class="col-12 py-1">
                                        <v-select
                                            v-model="form_data.due_day_of_month"
                                            :items="due_days_of_month"
                                            item-text="text"
                                            item-value="value"
                                            outlined
                                            class="task-form-elem pt-0"
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row
                                    v-if="
                                        form_data.type == 'yearly' ||
                                            form_data.type == 'monthly' ||
                                            form_data.type == 'quarterly'
                                    "
                                >
                                    <v-col class="col-12 pt-3 pb-1">
                                        <v-select
                                            v-model="form_data.due_shift_to_workday"
                                            :label="$t('In case of holiday')"
                                            :items="shifting"
                                            item-text="text"
                                            item-value="value"
                                            outlined
                                            class="task-form-elem"
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-if="form_data.due_date_type === 'plus_days'">
                                <v-row>
                                    <v-col class="col-6 pr-1 pb-1 py-1">
                                        <v-text-field
                                            v-model="form_data.due_count_days_f"
                                            outlined
                                            class="task-form-elem pt-0"
                                            hide-details
                                            :error-messages="form_data.due_count_days_error"
                                            @change="integer_field_changed('due_count_days', $event)"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col class="col-6 pr-1 pt-3 pb-1 py-1">
                                        {{ $t("days") }}
                                    </v-col>
                                </v-row>
                                <v-row v-if="calc_form_list.length > 1">
                                    <v-col class="col-12 py-1">
                                        <v-select
                                            v-model="form_data.due_calc_from"
                                            :items="calc_form_list"
                                            item-text="text"
                                            item-value="name"
                                            outlined
                                            class="task-form-elem pt-0"
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row v-if="due_calc_types.length > 1">
                                    <v-col class="col-12 py-1">
                                        <v-select
                                            v-model="form_data.due_calc_type"
                                            :items="due_calc_types"
                                            item-text="text"
                                            item-value="name"
                                            outlined
                                            class="task-form-elem pt-0"
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </template>
                            <v-row v-if="!show_due_time_field" class="px-3">
                                <v-col class="col-12 pa-0">
                                    <v-btn
                                        text
                                        small
                                        color="primary"
                                        style="text-transform: none;"
                                        @click="show_due_time_field = true"
                                    >
                                        + {{ $t("Set time") }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col class="col-12 pt-3 pb-1">
                                    <v-text-field
                                        v-model="form_data.due_time_f"
                                        outlined
                                        class="task-form-elem"
                                        :label="$t('Due date time')"
                                        hide-details="auto"
                                        :error-messages="form_data.due_time_error"
                                        @change="time_field_changed('due_time', $event)"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <template #footer>
                <secondary-button v-if="task.recurrence_rule" @click="onRemoveRecurrence">
                    {{ $t('Remove recurrence') }}
                </secondary-button>
                <v-spacer />
                <v-btn text @click="cancel">{{ $t("Cancel") }}</v-btn>
                <v-btn color="primary" class="inverted--text" :disabled="hasErrors" @click="save">{{ $t("Save") }}</v-btn>
            </template>
        </Dialog>
        <v-menu
            v-else
            v-model="menu_open"
            offset-y
            :close-on-content-click="false"
            :nudge-top="18"
            class="recurrence-menu"
        >
            <template #activator="{ on }">
                <RecurrenceButton
                    :label="label"
                    :current-state="current_state"
                    :can-add-repeat="canAddRepeat"
                    :menu-open="menu_open"
                    :error-messages="errorMessages"
                    :on="on"
                    @add-repeat="addRepeat"
                />
            </template>
            <v-card v-if="view_type === 'standard' && form_data">
                <v-card-text class="pt-0 pb-0">
                    <v-row>
                        <v-col class="pt-0">
                            <v-date-picker
                                :value="dates"
                                range
                                no-title
                                flat
                                :picker-date.sync="pickerDate"
                                width="304"
                                class="elevation-0 date-picker-range"
                                color="primary"
                                :events="coloring.events"
                                :event-color="coloring.colors"
                                :first-day-of-week="firstDayOfWeek"
                                @input="dates_changed"
                            ></v-date-picker>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="col-6 pr-2 pt-0">
                            <v-text-field
                                ref="startDateField"
                                outlined
                                class="task-form-elem task-form-elem-date"
                                :class="isStartDateActive ? 'date-picker-highlighted' : ''"
                                hide-details="auto"
                                :label="$t('Start date')"
                                :error-messages="form_data.date_error"
                                :value="typedDate !== null && isStartInputActive ? typedDate : formatDate(form_data.date)"
                                style="width: 132px;"
                                autofocus
                                @keyup.enter="typedDate = null; endDateField.focus();"
                                @input="onSetTextStartDate"
                                @focus="onFocusStartDate"
                                @blur="isStartInputActive = false; typedDate = null"
                            ></v-text-field>
                        </v-col>
                        <v-col class="col-6 pl-2 pt-0">
                            <v-text-field
                                ref="endDateField"
                                outlined
                                class="task-form-elem task-form-elem-date"
                                :class="isDueDateActive ? 'date-picker-highlighted' : ''"
                                hide-details
                                :label="$t('Due date')"
                                :value="typedDate !== null && isEndInputActive ? typedDate : formatDate(form_data.due_date)"
                                style="width: 132px;"
                                @keyup.enter="typedDate = null; startDateField.focus();"
                                @input="onSetTextEndDate"
                                @focus="onFocusEndDate"
                                @blur="isEndInputActive = false; typedDate = null"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="!show_time_fields" class="px-3">
                        <v-col class="col-12 px-0 pt-0">
                            <v-btn
                                text
                                small
                                color="primary"
                                style="text-transform: none;"
                                @click="show_time_fields = true"
                            >
                                + {{ $t("Set time") }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-else class="px-3">
                        <v-col class="col-6 pr-2 pt-0">
                            <v-text-field
                                v-model="form_data.time_f"
                                outlined
                                class="task-form-elem"
                                :label="$t('Start time')"
                                style="width: 132px;"
                                :error-messages="form_data.time_error"
                                :hide-details="!form_data.time_error"
                                @change="time_field_changed('time', $event)"
                            ></v-text-field>
                        </v-col>
                        <v-col class="col-6 pl-2 pt-0">
                            <v-text-field
                                v-model="form_data.due_time_f"
                                outlined
                                class="task-form-elem"
                                :label="$t('Due date time')"
                                style="width: 132px;"
                                :error-messages="form_data.due_time_error"
                                :hide-details="!form_data.due_time_error"
                                @change="time_field_changed('due_time', $event)"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="recurrence_enabled" class="px-3">
                        <v-col class="pt-0">
                            <dropdown
                                :items="simple_repeat_list"
                                :selected="simple_repeat_list.filter(x => x.name === form_data.type)"
                                name-key="text"
                                value-key="name"
                                show-selected-first
                                input-class="task-form-elem"
                                :bind-props="{
                                    'open-on-hover': false,
                                    'allow-overflow': false,
                                    'offset-y': true,
                                    'nudge-bottom': -4
                                }"
                                :searchable="false"
                                :label="$t('Repeat')"
                                @input="recurrence_changed($event.name)"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="dialog-actions-bar py-4 px-7">
                    <v-spacer />
                    <v-btn text @click="cancel">{{ $t("Cancel") }}</v-btn>
                    <v-btn color="primary" class="inverted--text" :disabled="hasErrors" @click="save">
                        {{ $t("Save") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
import Vue from "vue";
import { $t } from "@/i18n";
import { ref, computed, watch } from "@vue/composition-api";
import {
    formatNumber,
    formatWeekday,
    parseSysDate,
    cleanNumber,
    formatSysDate,
    formatSysDateTime,
    parseTime,
    parseDate,
    formatMonthName,
    formatRecurrence,
    formatDate
} from "@/plugins/formatting";
import Dialog from "@/components/Dialog.vue"
import RecurrenceButton from "@/components/Task/RecurrenceField/RecurrenceButton.vue";

export default {
    name: "RecurrenceField",
    components: {
        Dialog,
        RecurrenceButton
    },
    props: {
        label: {
            type: String,
            default: null
        },
        task: {
            type: Object,
            required: true
        },
        errorMessages: {
            type: String,
            default: null
        },
        pickerType: {
            type: String,
            default: "standard"
        }
    },
    setup(props, ctx) {
        const menu_open = ref(false);
        const form_data = ref(null);
        const dates = ref([]);
        const show_time_fields = ref(false);
        const show_start_time_field = ref(false);
        const show_due_time_field = ref(false);
        const repeatAdded = ref(false);
        const view_type = ref(props.pickerType);
        const typedDate = ref(null)
        const isStartInputActive = ref(false)
        const isEndInputActive = ref(false)
        const endDateField = ref(null)
        const startDateField = ref(null)
        const pickerDate = ref(null)
        const activeField = ref('start_date')

        const types = ref([
            { name: "monthly", text: $t("month") },
            { name: "weekly", text: $t("week") },
            { name: "quarterly", text: $t("quarter") },
            { name: "yearly", text: $t("year") }
        ]);
        const months_of_year = ref([
            { value: 1, text: $t("January") },
            { value: 2, text: $t("February") },
            { value: 3, text: $t("March") },
            { value: 4, text: $t("April") },
            { value: 5, text: $t("May") },
            { value: 6, text: $t("June") },
            { value: 7, text: $t("July") },
            { value: 8, text: $t("August") },
            { value: 9, text: $t("September") },
            { value: 10, text: $t("October") },
            { value: 11, text: $t("November") },
            { value: 12, text: $t("December") }
        ]);
        const months_of_quarter = ref([
            { value: 1, text: $t("1st month") },
            { value: 2, text: $t("2nd month") },
            { value: 3, text: $t("3rd month") }
        ]);
        const days_of_month = computed(() => {
            let daysInMonth = 31
            if (form_data.value.type === 'yearly') {
                const leapYearWithSelectedMonth = new Date(2016, form_data.value.month_of_year - 1, 1)
                daysInMonth = leapYearWithSelectedMonth.calcDaysInMonth()
            }

            let ret = [];
            for (let i = 1; i <= daysInMonth; i++) {
                ret.push({ value: i, text: $t("Day {0}").format(i) });
            }
            return ret;

        })

        const due_days_of_month = computed(() => {
            let daysInMonth = 31
            if (form_data.value.type === 'yearly') {
                const leapYearWithSelectedMonth = new Date(2016, form_data.value.due_month_of_year - 1, 1)
                daysInMonth = leapYearWithSelectedMonth.calcDaysInMonth()
            }

            let ret = [];
            for (let i = 1; i <= daysInMonth; i++) {
                ret.push({ value: i, text: $t("Day {0}").format(i) });
            }
            return ret;

        })

        const days_of_week = ref([
            { value: 1, text: $t("Monday") },
            { value: 2, text: $t("Tuesday") },
            { value: 3, text: $t("Wednesday") },
            { value: 4, text: $t("Thursday") },
            { value: 5, text: $t("Friday") },
            { value: 6, text: $t("Saturday") },
            { value: 7, text: $t("Sunday") }
        ]);
        const shifting = ref([
            { value: -1, text: $t("Show before") },
            { value: 0, text: $t("Keep the day") },
            { value: 1, text: $t("Show after") }
        ]);
        const date_menu_open = ref(false);

        const icon = computed(() => {
            return !current_state.value || !current_state.value.type || current_state.value.type === "date"
                ? "CalendarDays"
                : "RotateCw";
        });
        const calc_form_list = computed(function() {
            if (
                form_data.value && (
                form_data.value.type === "weekly" ||
                form_data.value.type === "quarterly" ||
                form_data.value.type === "yearly"
            )) {
                return [{ name: "start_date", text: $t("From start date") }];
            }
            return [
                { name: "start_date", text: $t("From start date") },
                { name: "month_start", text: $t("From beginning of the month") }
            ];
        });
        const due_calc_types = computed(function() {
            if (form_data.value && form_data.value.type === "weekly") {
                return [{ name: "calendar_days", text: $t("All days (Mon to Sun)") }];
            }
            return [
                { name: "calendar_days", text: $t("All days (Mon to Sun)") },
                { name: "mon_fri_days", text: $t("Mon to Fri (incl. holidays)") },
                { name: "work_days", text: $t("Mon to Fri (excl. holidays)") }
            ];
        });
        const simple_repeat_list = computed(function() {
            if (form_data.value == null) return [];
            if (!form_data.value.date) {
                return []
            }

            let d = parseSysDate(form_data.value.date);

            let day = d.getDate();
            let month_no = (d.getMonth() % 3) + 1;
            let month_no_str = month_no == 1 ? $t("1st") : month_no == 2 ? $t("2nd") : $t("3rd");

            let ret = [];
            ret.push({ name: "date", text: $t("Does not repeat") });
            //ret.push({name: "daily", text: $t("Daily")});
            ret.push({ name: "weekly", text: $t("Weekly on {0}").format(formatWeekday(d)) });
            ret.push({ name: "monthly", text: $t("Monthly on day {0}").format(day) });
            ret.push({ name: "quarterly", text: $t("Quarterly on {0} month {1} day").format(month_no_str, day) });
            ret.push({ name: "yearly", text: $t("Yearly on {0} {1}").format(day, formatMonthName(d)) });
            ret.push({ name: "custom", text: $t("Custom...") });
            return ret;
        });

        const locale = computed(function() {
            return Vue.formatting.culture;
        });
        const firstDayOfWeek = computed(function () {
            return Vue.formatting.first_week_day
        })
        const coloring = computed(function() {
            let ret = { events: [], colors: {}};
            if (!form_data.value) {
                return ret;
            }
            if (form_data.value.date === form_data.value.due_date) {
                let d = form_data.value.date.substr(0, 10);
                ret.events.push(d);
                ret.colors[d] = "date-range__date-in-range date-range__range-single blue lighten-3";
                return ret;
            }

            let from = parseSysDate(form_data.value.date.substr(0, 10));
            let until = parseSysDate(form_data.value.due_date.substr(0, 10));
            if (until < from) {
                until = parseSysDate(form_data.value.date.substr(0, 10));
                from = parseSysDate(form_data.value.due_date.substr(0, 10));
            }

            let current = from;
            while (current <= until) {
                let d = formatSysDate(current);
                ret.events.push(d);
                ret.colors[d] = "date-range__date-in-range blue lighten-3";
                current.setDate(current.getDate() + 1);
            }
            ret.colors[ret.events[0]] += " date-range__range-start";
            ret.colors[ret.events[ret.events.length - 1]] += " date-range__range-end";

            return ret;
        });

        const current_state = computed(function() {
            if (props.task.recurrence_rule == null) {
                let ret = {
                    type: "date",
                    date: props.task.date,
                    date_only: props.task.date_only,
                    has_due_date: props.task.has_due_date,
                    due_date: props.task.due_date,
                    due_date_only: props.task.due_date_only,
                    time: props.task.date_only ? "" : props.task.date.length >= 16 ? props.task.date.substr(11, 5) : "",
                    due_time: props.task.due_date_only
                        ? ""
                        : props.task.due_date && props.task.due_date.length >= 16
                            ? props.task.due_date.substr(11, 5)
                            : ""
                };
                return ret;
            }
            return props.task.recurrence_rule;
        });
        const recurrence_enabled = computed(function() {
            // disable for recurrence instances
            if (props.task.recurrence_id !== undefined && props.task.recurrence_id != null) return false;
            // enable for template tasks
            if (props.task.recurrence_rule != null) return true;
            // enable for new tasks and disable for existing
            // hack
            return !props.task.id || (props.task.id && typeof props.task.id === 'string' && props.task.id.startsWith('tmp'))
        });

        const load_data = () => {
            let recurrence_rule = null;
            if (props.task.recurrence_rule == null) {
                recurrence_rule = {
                    type: "date",
                    date: props.task.date == null ? formatSysDate(new Date()) : props.task.date,
                    date_only: props.task.date_only,
                    has_due_date: props.task.has_due_date,
                    due_date: props.task.due_date == null ? formatSysDate(new Date()) : props.task.due_date,
                    due_date_only: props.task.due_date_only,
                    time: props.task.date_only ? "" : props.task.date.length >= 16 ? props.task.date.substr(11, 8) : "",
                    due_time: props.task.due_date_only
                        ? ""
                        : props.task.due_date && props.task.due_date.length >= 16
                            ? props.task.due_date.substr(11, 8)
                            : ""
                };
                // console.warn('1 - recurrence_rule', recurrence_rule)
            }
            else {
                recurrence_rule = Vue.clone_object(props.task.recurrence_rule);
                // console.warn('2 - recurrence_rule', recurrence_rule)
            }

            let open_custom = null;

            switch (recurrence_rule.type) {
                case "weekly":
                    if (recurrence_rule.weekdays.length === 1) {
                        let date = parseSysDate(recurrence_rule.date);
                        let weekday = date.getDay() === 0 ? 7 : date.getDay();
                        date.setDate(date.getDate() + (recurrence_rule.weekdays[0] - weekday));
                        recurrence_rule.date = formatSysDate(date);

                        if (recurrence_rule.has_due_date) {
                            if (recurrence_rule.due_calc_type === "date") {
                                let due_date = parseSysDate(recurrence_rule.date);
                                due_date.setDate(due_date.getDate() + recurrence_rule.due_count_days);
                                recurrence_rule.due_date = formatSysDate(due_date);
                            } else {
                                recurrence_rule.due_date_type = "plus_days";
                                recurrence_rule.due_date = recurrence_rule.date;
                                open_custom = "custom";
                            }
                        } else {
                            recurrence_rule.due_date = recurrence_rule.date;
                            recurrence_rule.due_date_only = recurrence_rule.date_only;
                        }
                    } else {
                        recurrence_rule.due_date_type = recurrence_rule.has_due_date ? "plus_days" : null;
                        recurrence_rule.due_date = recurrence_rule.date;
                        open_custom = "custom";
                    }
                    break;
                case "monthly": {
                    if (!recurrence_rule.day_of_month) recurrence_rule.day_of_month = 1;
                    if (!recurrence_rule.due_day_of_month)
                        recurrence_rule.due_day_of_month = recurrence_rule.day_of_month;
                    if (!recurrence_rule.shift_to_workday) recurrence_rule.shift_to_workday === 0;

                    let date = parseSysDate(recurrence_rule.date);
                    let max_days = 1;
                    recurrence_rule.date = formatSysDate(date);

                    if (recurrence_rule.shift_to_workday !== 0) {
                        open_custom = "custom";
                    }

                    if (recurrence_rule.has_due_date) {
                        if (!recurrence_rule.due_calc_type) recurrence_rule.due_calc_type = "date";
                        if (!recurrence_rule.due_shift_to_workday) recurrence_rule.due_shift_to_workday = 0;

                        if (recurrence_rule.due_shift_to_workday !== 0) {
                            open_custom = "custom";
                        }

                        if (recurrence_rule.due_calc_type === "date") {
                            let due_date = parseSysDate(recurrence_rule.date);
                            if (recurrence_rule.day_of_month > recurrence_rule.due_day_of_month) {
                                due_date = due_date.calcNextMonth();
                            }

                            //max_days = Vue.calc_days_in_month(due_date.getFullYear(), due_date.getMonth());
                            max_days = due_date.calcDaysInMonth();
                            due_date.setDate(Math.min(recurrence_rule.due_day_of_month, max_days));
                            recurrence_rule.due_date = formatSysDate(due_date);
                            recurrence_rule.due_date_type = "on_date";
                        } else {
                            recurrence_rule.due_date_type = "plus_days";
                            recurrence_rule.due_date = recurrence_rule.date;
                            open_custom = "custom";
                        }
                    } else {
                        recurrence_rule.due_date = recurrence_rule.date;
                        recurrence_rule.due_date_only = recurrence_rule.date_only;
                        recurrence_rule.due_time = recurrence_rule.time;
                    }
                    // console.warn('load data monthly -', recurrence_rule)

                    break;
                }
                case "quarterly": {
                    if (!recurrence_rule.month_of_period) recurrence_rule.month_of_period = 1;
                    if (!recurrence_rule.day_of_month) recurrence_rule.day_of_month = 1;

                    if (!recurrence_rule.due_month_of_period)
                        recurrence_rule.due_month_of_period = recurrence_rule.month_of_period;
                    if (!recurrence_rule.due_day_of_month)
                        recurrence_rule.due_day_of_month = recurrence_rule.day_of_month;

                    if (!recurrence_rule.shift_to_workday) recurrence_rule.shift_to_workday === 0;

                    //let now = new Date();
                    //let cur_quarter = Math.ceil((now.getMonth() + 1) / 3);
                    //let date_month = (cur_quarter - 1) * 3 + recurrence_rule.month_of_period;
                    //let date = new Date(now.getFullYear(), date_month - 1, 1);
                    //let max_days = date.calcDaysInMonth();
                    //date.setDate(Math.min(recurrence_rule.day_of_month, max_days));
                    let date = parseSysDate(recurrence_rule.date);
                    recurrence_rule.date = formatSysDate(date);
                    recurrence_rule.month_of_quarter = recurrence_rule.month_of_period;

                    if (recurrence_rule.shift_to_workday !== 0) {
                        open_custom = "custom";
                    }

                    if (recurrence_rule.has_due_date) {
                        if (!recurrence_rule.due_calc_type) recurrence_rule.due_calc_type = "date";
                        if (!recurrence_rule.due_shift_to_workday) recurrence_rule.due_shift_to_workday = 0;

                        if (recurrence_rule.due_shift_to_workday !== 0) {
                            open_custom = "custom";
                        }

                        if (recurrence_rule.due_calc_type === "date") {
                            let cur_quarter = Math.ceil((date.getMonth() + 1) / 3);
                            let due_date_month = (cur_quarter - 1) * 3 + recurrence_rule.due_month_of_period;
                            let due_date = new Date(date.getFullYear(), due_date_month - 1, 1);
                            let max_days = due_date.calcDaysInMonth();
                            due_date.setDate(Math.min(recurrence_rule.due_day_of_month, max_days));
                            recurrence_rule.due_date = formatSysDate(due_date);
                            recurrence_rule.due_month_of_quarter = recurrence_rule.due_month_of_period;
                            recurrence_rule.due_date_type = "on_date";
                        } else {
                            recurrence_rule.due_date_type = "plus_days";
                            recurrence_rule.due_date = recurrence_rule.date;
                            open_custom = "custom";
                        }
                    } else {
                        recurrence_rule.due_date = recurrence_rule.date;
                        recurrence_rule.due_date_only = recurrence_rule.date_only;
                        recurrence_rule.due_time = recurrence_rule.time;
                    }
                    break;
                }
                case "yearly": {
                    if (!recurrence_rule.month_of_period) recurrence_rule.month_of_period = 1;
                    if (!recurrence_rule.day_of_month) recurrence_rule.day_of_month = 1;

                    if (!recurrence_rule.due_month_of_period)
                        recurrence_rule.due_month_of_period = recurrence_rule.month_of_period;
                    if (!recurrence_rule.due_day_of_month)
                        recurrence_rule.due_day_of_month = recurrence_rule.day_of_month;

                    let now = new Date();
                    let date = new Date(now.getFullYear(), recurrence_rule.month_of_period - 1, 1);
                    //let max_days = Vue.calc_days_in_month(date.getFullYear(), date.getMonth());
                    let max_days = date.calcDaysInMonth();
                    date.setDate(Math.min(recurrence_rule.day_of_month, max_days));
                    recurrence_rule.date = formatSysDate(date);
                    recurrence_rule.month_of_year = recurrence_rule.month_of_period;

                    if (recurrence_rule.shift_to_workday !== 0) {
                        open_custom = "custom";
                    }

                    if (recurrence_rule.has_due_date) {
                        if (!recurrence_rule.due_calc_type) recurrence_rule.due_calc_type = "date";
                        if (!recurrence_rule.due_shift_to_workday) recurrence_rule.due_shift_to_workday = 0;

                        if (recurrence_rule.due_shift_to_workday !== 0) {
                            open_custom = "custom";
                        }

                        if (recurrence_rule.due_calc_type === "date") {
                            let due_date = new Date(now.getFullYear(), recurrence_rule.due_month_of_period - 1, 1);
                            //max_days = Vue.calc_days_in_month(due_date.getFullYear(), due_date.getMonth());
                            max_days = due_date.calcDaysInMonth();
                            due_date.setDate(Math.min(recurrence_rule.due_day_of_month, max_days));
                            if (due_date < date) {
                                due_date.setFullYear(due_date.getFullYear() + 1)
                            }

                            recurrence_rule.due_date = formatSysDate(due_date);
                            recurrence_rule.due_month_of_year = recurrence_rule.due_month_of_period;
                            recurrence_rule.due_date_type = "on_date";
                        } else {
                            recurrence_rule.due_date_type = "plus_days";
                            recurrence_rule.due_date = recurrence_rule.date;
                            open_custom = "custom";
                        }
                    } else {
                        recurrence_rule.due_date = recurrence_rule.date;
                        recurrence_rule.due_date_only = recurrence_rule.date_only;
                        recurrence_rule.due_time = recurrence_rule.time;
                    }

                    const leapYearWithSelectedMonth = new Date(2016, recurrence_rule.month_of_year - 1, 1)
                    const daysInMonth = leapYearWithSelectedMonth.calcDaysInMonth()

                    const leapYearWithSelectedDueMonth = new Date(2016, recurrence_rule.due_month_of_year - 1, 1)
                    const dueDaysInMonth = leapYearWithSelectedDueMonth.calcDaysInMonth()

                    if (recurrence_rule.day_of_month > daysInMonth) {
                        recurrence_rule.day_of_month = daysInMonth
                    }

                    if (recurrence_rule.due_day_of_month > dueDaysInMonth) {
                        recurrence_rule.due_day_of_month = dueDaysInMonth
                    }

                    break;
                }
            }

            let interval = recurrence_rule.interval ? recurrence_rule.interval : 1;
            if (interval !== 1 && recurrence_rule.type !== "date") open_custom = "custom";

            recurrence_rule = Vue.prepare_form_data(recurrence_rule, {
                type: "choice_single",
                date: "date",
                date_only: "boolean",
                time: "time",
                interval: "integer",
                weekdays: "list",
                day_of_month: "integer",
                month_of_period: "integer",
                month_of_quarter: "integer",
                month_of_year: "integer",
                shift_to_workday: "integer",
                has_due_date: "boolean",
                due_date: "date",
                due_date_only: "boolean",
                due_time: "time",
                due_day_of_month: "integer",
                due_month_of_period: "integer",
                due_month_of_quarter: "integer",
                due_month_of_year: "integer",
                due_shift_to_workday: "integer",
                due_count_days: "integer",
                due_calc_from: "choice_single",
                due_calc_type: "choice_single",
                due_date_type: "choice_single",
            });

            // custom_view.value = open_custom;
            if (open_custom && view_type.value === "standard")
                view_type.value = open_custom;

            if (props.task.recurrence_rule) {
                view_type.value = 'custom'
            }

            if (props.task.recurrence_rule) {
                recurrence_rule.date = null
            }

            show_time_fields.value = !recurrence_rule.date_only || !recurrence_rule.due_date_only;
            show_start_time_field.value = !recurrence_rule.date_only;
            show_due_time_field.value = !recurrence_rule.due_date_only;

            form_data.value = recurrence_rule;
            dates.value = [recurrence_rule.date ? recurrence_rule.date.substr(0, 10) : null, recurrence_rule.due_date ? recurrence_rule.due_date.substr(0, 10) : null];

            if (view_type.value === 'custom') {
                setCustomRecurrenceDate()
            }
        };

        const setCustomRecurrenceDate = () => {
            const prevDate = parseSysDate(props.task.date)
            const startOfMonthDate = new Date()
            startOfMonthDate.setDate(1)

            let newDate

            if (prevDate > startOfMonthDate) {
                newDate = prevDate
            } else {
                const startOfMonthDate = new Date()
                startOfMonthDate.setDate(1)

                newDate = startOfMonthDate
            }

            form_data.value.date = formatSysDate(newDate)
        }

        watch(menu_open, function(val) {
            if (val) {
                load_data();
                if (repeatAdded.value) {
                    // reverted change, must analyse first
                    if (view_type.value !== 'custom') {
                        recurrence_changed('custom')
                    }
                }
            }
            else {
                form_data.value = null;
                //custom_view.value = false;
                view_type.value = props.pickerType;
                repeatAdded.value = false
            }
        });

        const get_clean_value = function() {
            switch (view_type.value) {
                case "standard":
                    return get_clean_value_simple();
                case "custom":
                    return get_clean_value_custom();
            }
            return null;
        };

        const get_clean_value_simple = function() {
            let recurrence_rule = {
                type: form_data.value.type,
                date: form_data.value.date.substr(0, 10),
                date_only: !show_time_fields.value || !form_data.value.time,
                time: null
            };
            if (!recurrence_rule.date_only) recurrence_rule.time = form_data.value.time.substr(0, 8);
            if (recurrence_rule.type !== "date") recurrence_rule.interval = 1;

            switch (recurrence_rule.type) {
                case "date":
                    return get_clean_value_simple_date(recurrence_rule);
                case "weekly":
                    return get_clean_value_simple_weekly(recurrence_rule);
                case "monthly":
                    return get_clean_value_simple_monthly(recurrence_rule);
                case "quarterly":
                    return get_clean_value_simple_q_or_y(recurrence_rule);
                case "yearly":
                    return get_clean_value_simple_q_or_y(recurrence_rule);
            }
            return null;
        };
        const get_clean_value_simple_date = function(recurrence_rule) {
            let due_date = {
                due_date: form_data.value.due_date.substr(0, 10),
                due_date_only: !show_time_fields.value || !form_data.value.due_time,
                due_time: null
            };
            if (!due_date.due_date_only) due_date.due_time = form_data.value.due_time.substr(0, 8);

            if (
                recurrence_rule.date !== due_date.due_date ||
                recurrence_rule.date_only !== due_date.due_date_only ||
                recurrence_rule.time !== due_date.due_time
            ) {
                recurrence_rule.has_due_date = 1;
                recurrence_rule.due_date = due_date.due_date;
                recurrence_rule.due_date_only = due_date.due_date_only;
                recurrence_rule.due_time = due_date.due_time;
            } else {
                recurrence_rule.has_due_date = 0;
            }
            return recurrence_rule;
        };
        const get_clean_value_simple_weekly = function(recurrence_rule) {
            recurrence_rule.weekdays = form_data.value.weekdays;

            let due_date = {
                due_date: form_data.value.due_date.substr(0, 10),
                due_date_only: !show_time_fields.value || !form_data.value.due_time,
                due_time: null
            };
            if (!due_date.due_date_only) due_date.due_time = form_data.value.due_time.substr(0, 8);

            if (
                recurrence_rule.date !== due_date.due_date ||
                recurrence_rule.date_only !== due_date.due_date_only ||
                recurrence_rule.time !== due_date.due_time
            ) {
                let d = parseSysDate(form_data.value.date);
                let dd = parseSysDate(form_data.value.due_date);

                recurrence_rule.has_due_date = 1;
                recurrence_rule.due_date_only = due_date.due_date_only;
                recurrence_rule.due_time = due_date.due_time;
                recurrence_rule.due_calc_from = "start_date";
                recurrence_rule.due_calc_type = "calendar_days";
                recurrence_rule.due_count_days = Math.round((dd - d) / (1000 * 60 * 60 * 24));
            } else {
                recurrence_rule.has_due_date = 0;
            }

            return recurrence_rule;
        };
        const get_clean_value_simple_monthly = function(recurrence_rule) {
            recurrence_rule.day_of_month = form_data.value.day_of_month;
            recurrence_rule.shift_to_workday = 0;

            let due_date = {
                due_date: form_data.value.due_date.substr(0, 10),
                due_date_only: !show_time_fields.value || !form_data.value.due_time,
                due_time: null
            };
            if (!due_date.due_date_only) due_date.due_time = form_data.value.due_time.substr(0, 8);

            if (
                recurrence_rule.date !== due_date.due_date ||
                recurrence_rule.date_only !== due_date.due_date_only ||
                recurrence_rule.time !== due_date.due_time
            ) {
                // let d = Vue.parse_sys_date(form_data.value.date);
                // let dd = Vue.parse_sys_date(form_data.value.due_date);

                recurrence_rule.has_due_date = 1;
                recurrence_rule.due_calc_type = "date";
                recurrence_rule.due_day_of_month = form_data.value.due_day_of_month;
                recurrence_rule.due_date_only = due_date.due_date_only;
                recurrence_rule.due_time = due_date.due_time;
                recurrence_rule.due_shift_to_workday = 0;
            } else {
                recurrence_rule.has_due_date = 0;
            }

            return recurrence_rule;
        };
        const get_clean_value_simple_q_or_y = function(recurrence_rule) {
            recurrence_rule.month_of_period = form_data.value.month_of_period;
            recurrence_rule.day_of_month = form_data.value.day_of_month;
            recurrence_rule.shift_to_workday = 0;

            let due_date = {
                due_date: form_data.value.due_date.substr(0, 10),
                due_date_only: !show_time_fields.value || !form_data.value.due_time,
                due_time: null
            };
            if (!due_date.due_date_only) due_date.due_time = form_data.value.due_time.substr(0, 8);

            if (
                recurrence_rule.date !== due_date.due_date ||
                recurrence_rule.date_only !== due_date.due_date_only ||
                recurrence_rule.time !== due_date.due_time
            ) {
                // let d = Vue.parse_sys_date(form_data.value.date);
                // let dd = Vue.parse_sys_date(form_data.value.due_date);

                recurrence_rule.has_due_date = 1;
                recurrence_rule.due_calc_type = "date";
                recurrence_rule.due_month_of_period = form_data.value.due_month_of_period;
                recurrence_rule.due_day_of_month = form_data.value.due_day_of_month;
                recurrence_rule.due_date_only = due_date.due_date_only;
                recurrence_rule.due_time = due_date.due_time;
                recurrence_rule.due_shift_to_workday = 0;
            } else {
                recurrence_rule.has_due_date = 0;
            }

            return recurrence_rule;
        };

        const get_clean_value_custom = function() {
            let recurrence_rule = {
                type: form_data.value.type,
                interval: form_data.value.interval,
                date: form_data.value.date ? form_data.value.date.substr(0, 10) : null,
                date_only: !show_start_time_field.value || !form_data.value.time,
                time: null,
                has_due_date: 0,
                due_date_only: 1,
                due_time: null
            };
            if (!recurrence_rule.date_only) recurrence_rule.time = form_data.value.time.substr(0, 8);

            if (show_due_time_field.value && form_data.value.due_time) {
                recurrence_rule.due_date_only = 0;
                recurrence_rule.due_time = form_data.value.due_time.substr(0, 8);
                recurrence_rule.has_due_date = 1;
            }

            switch (recurrence_rule.type) {
                case "weekly":
                    return get_clean_value_custom_weekly(recurrence_rule);
                case "monthly":
                    return get_clean_value_custom_monthly(recurrence_rule);
                case "quarterly":
                    form_data.value.month_of_period = form_data.value.month_of_quarter;
                    form_data.value.due_month_of_period = form_data.value.due_month_of_quarter;
                    return get_clean_value_custom_q_or_y(recurrence_rule);
                case "yearly":
                    form_data.value.month_of_period = form_data.value.month_of_year;
                    form_data.value.due_month_of_period = form_data.value.due_month_of_year;
                    return get_clean_value_custom_q_or_y(recurrence_rule);
            }
            return null;
        };
        const get_clean_value_custom_weekly = function(recurrence_rule) {
            recurrence_rule.weekdays = form_data.value.weekdays;

            if (form_data.value.due_date_type === "plus_days" && form_data.value.due_count_days != null) {
                recurrence_rule.due_count_days =
                    form_data.value.due_count_days >= 0 ? form_data.value.due_count_days : 0;
                recurrence_rule.has_due_date = 1;
            }

            if (recurrence_rule.has_due_date) {
                recurrence_rule.due_calc_from = "start_date";
                recurrence_rule.due_calc_type = "calendar_days";
            }

            return recurrence_rule;
        };
        const get_clean_value_custom_monthly = function(recurrence_rule) {
            recurrence_rule.day_of_month = form_data.value.day_of_month;
            recurrence_rule.shift_to_workday = form_data.value.shift_to_workday;

            if (form_data.value.due_date_type === "plus_days" && form_data.value.due_count_days != null) {
                recurrence_rule.due_count_days =
                    form_data.value.due_count_days >= 0 ? form_data.value.due_count_days : 0;
                recurrence_rule.due_calc_type = form_data.value.due_calc_type;
                recurrence_rule.due_calc_from = form_data.value.due_calc_from;
                recurrence_rule.has_due_date = 1;
            } else if (form_data.value.due_date_type === "on_date" && form_data.value.due_day_of_month != null) {
                if (form_data.value.due_day_of_month < 1) recurrence_rule.due_day_of_month = 1;
                else if (form_data.value.due_day_of_month > 31) recurrence_rule.due_day_of_month = 31;
                else recurrence_rule.due_day_of_month = form_data.value.due_day_of_month;

                recurrence_rule.due_calc_type = "date";
                recurrence_rule.due_shift_to_workday = form_data.value.due_shift_to_workday;
                recurrence_rule.has_due_date = 1;
            }
            return recurrence_rule;
        };
        const get_clean_value_custom_q_or_y = function(recurrence_rule) {
            recurrence_rule.month_of_period = form_data.value.month_of_period;
            recurrence_rule.day_of_month = form_data.value.day_of_month;
            recurrence_rule.shift_to_workday = form_data.value.shift_to_workday;

            if (form_data.value.due_date_type === "plus_days" && form_data.value.due_count_days != null) {
                recurrence_rule.due_count_days =
                    form_data.value.due_count_days >= 0 ? form_data.value.due_count_days : 0;
                recurrence_rule.due_calc_type = form_data.value.due_calc_type;
                recurrence_rule.due_calc_from = "start_date";
                recurrence_rule.has_due_date = 1;
            } else if (form_data.value.due_date_type === "on_date" && form_data.value.due_day_of_month != null) {
                if (form_data.value.due_day_of_month < 1) recurrence_rule.due_day_of_month = 1;
                else if (form_data.value.due_day_of_month > 31) recurrence_rule.due_day_of_month = 31;
                else recurrence_rule.due_day_of_month = form_data.value.due_day_of_month;

                recurrence_rule.due_month_of_period = form_data.value.due_month_of_period;
                recurrence_rule.due_calc_type = "date";
                recurrence_rule.due_shift_to_workday = form_data.value.due_shift_to_workday;
                recurrence_rule.has_due_date = 1;
            }

            return recurrence_rule;
        };

        const validateStartFromRequired = function() {
            if (view_type.value !== 'custom') {
                return true
            }

            if (!form_data.value['date']) {
                form_data.value["date_error"] = $t('Required field');
                return false;
            }

            return true
        };

        const validateStartNotGreaterThanEndDate = function() {
            if (view_type.value === 'custom') {
                return true
            }

            const startDate = parseSysDate(form_data.value['date'])
            const dueDate = parseSysDate(form_data.value['due_date'])

            if (startDate > dueDate) {
                form_data.value["date_error"] = $t('Start date cannot be later than due date');
                return false
            }

            return true
        };

        const save = (e) => {
            form_data.value["date_error"] = null;

            if (!validateStartFromRequired()) {
                return
            }

            if (!validateStartNotGreaterThanEndDate()) {
                return
            }

            ctx.emit("change", get_clean_value());
            menu_open.value = false;

            // Assume enter is pressed
            if (e.clientX === 0 && e.clientY === 0) {
                ctx.emit("tab_next");
            }
        };
        const cancel = () => {
            menu_open.value = false;
            ctx.emit("tab_next");
        };

        const textDatesChanged = function() {
            form_data.value.date_error = null

            if (dates.value.length === 0) {
                form_data.value.date = form_data.value.due_date = formatSysDateTime(new Date());
            } else if (dates.value.length === 1) {
                dates.value[1] = form_data.value.due_date
                form_data.value.date = dates.value[0];
            } else {
                form_data.value.date = dates.value[0];
                form_data.value.due_date = dates.value[1];
            }
        };

        const dates_changed = function(newDates) {
            if (isStartDateActive.value) {
                dates.value[0] = newDates[0]
                if (dates.value[1] && parseSysDate(dates.value[1]) < parseSysDate(dates.value[0])) {
                    dates.value[1] = dates.value[0]
                }

                activeField.value = 'due_date'
                endDateField.value.$refs.input.select();
            } else if (isDueDateActive.value) {
                dates.value[1] = newDates[newDates.length - 1]
                if (parseSysDate(dates.value[1]) < parseSysDate(dates.value[0])) {
                    dates.value[0] = dates.value[1]
                }

                activeField.value = 'start_date'
                startDateField.value.$refs.input.select();
            }

            form_data.value.date_error = null

            if (dates.value.length === 0) {
                form_data.value.date = form_data.value.due_date = formatSysDateTime(new Date());
            } else if (dates.value.length === 1) {
                form_data.value.date = form_data.value.due_date = dates.value[0];
            } else {
                form_data.value.date = dates.value[dates.value[0] <= dates.value[1] ? 0 : 1];
                form_data.value.due_date = dates.value[dates.value[0] <= dates.value[1] ? 1 : 0];
            }

            let d = parseSysDate(form_data.value.date);
            let dd = parseSysDate(form_data.value.due_date);

            switch (form_data.value.type) {
                case "weekly":
                    form_data.value.weekdays = [d.getDay() === 0 ? 7 : d.getDay()];
                    form_data.value.interval = 1;
                    form_data.value.due_date_type = "plus_days";
                    form_data.value.due_calc_from = "start_date";
                    form_data.value.due_calc_type = "calendar_days";
                    form_data.value.due_count_days = Math.round((dd - d) / (1000 * 60 * 60 * 24));
                    break;
                case "monthly":
                    form_data.value.interval = 1;
                    form_data.value.day_of_month = d.getDate();
                    form_data.value.due_date_type = "on_date";
                    form_data.value.due_day_of_month = dd.getDate();
                    break;
                case "quarterly":
                    form_data.value.interval = 1;
                    form_data.value.day_of_month = d.getDate();
                    form_data.value.month_of_period = (d.getMonth() % 3) + 1;
                    form_data.value.month_of_quarter = (d.getMonth() % 3) + 1;
                    form_data.value.due_date_type = "on_date";
                    form_data.value.due_day_of_month = dd.getDate();
                    form_data.value.due_month_of_period = (dd.getMonth() % 3) + 1;
                    form_data.value.due_month_of_quarter = (dd.getMonth() % 3) + 1;
                    break;
                case "yearly":
                    form_data.value.interval = 1;
                    form_data.value.day_of_month = d.getDate();
                    form_data.value.month_of_period = d.getMonth() + 1;
                    form_data.value.month_of_year = d.getMonth() + 1;
                    form_data.value.due_date_type = "on_date";
                    form_data.value.due_day_of_month = dd.getDate();
                    form_data.value.due_month_of_period = dd.getMonth() + 1;
                    form_data.value.due_month_of_year = dd.getMonth() + 1;
                    break;
            }

            form_data.value.interval_f = formatNumber(form_data.value.interval);
        };
        const recurrence_changed = function(data) {
            if (!recurrence_enabled.value) return;

            let d = parseSysDate(form_data.value.date ? form_data.value.date : props.task.date);
            let dd = parseSysDate(form_data.value.due_date ? form_data.value.due_date : props.task.due_date);
            form_data.value.shift_to_workday = 0;
            form_data.value.due_shift_to_workday = 0;

            switch (data) {
                case "date":
                    form_data.value.type = "date";
                    form_data.value.due_date_type = "on_date";
                    form_data.value.date = formatSysDate(d)
                    form_data.value.due_date = formatSysDate(dd)
                    view_type.value = "standard";
                    break;
                case "weekly":
                    form_data.value.type = "weekly";
                    form_data.value.interval = 1;
                    form_data.value.weekdays = [d.getDay() === 0 ? 7 : d.getDay()];
                    form_data.value.due_date_type = "plus_days";
                    form_data.value.due_calc_from = "start_date";
                    form_data.value.due_calc_type = "calendar_days";
                    form_data.value.due_count_days = view_type.value === "custom"
                        ? 0
                        : Math.round((dd - d) / (1000 * 60 * 60 * 24));
                    break;
                case "monthly":
                    form_data.value.type = "monthly";
                    form_data.value.interval = 1;
                    form_data.value.day_of_month = d.getDate();
                    form_data.value.due_day_of_month = dd.getDate();
                    form_data.value.due_date_type = "on_date";
                    break;
                case "quarterly":
                    form_data.value.type = "quarterly";
                    form_data.value.interval = 1;
                    form_data.value.day_of_month = d.getDate();
                    form_data.value.month_of_period = (d.getMonth() % 3) + 1;
                    form_data.value.month_of_quarter = (d.getMonth() % 3) + 1;
                    form_data.value.due_day_of_month = dd.getDate();
                    form_data.value.due_month_of_period = (dd.getMonth() % 3) + 1;
                    form_data.value.due_month_of_quarter = (dd.getMonth() % 3) + 1;
                    form_data.value.due_date_type = "on_date";
                    break;
                case "yearly":
                    form_data.value.type = "yearly";
                    form_data.value.interval = 1;
                    form_data.value.day_of_month = d.getDate();
                    form_data.value.month_of_period = d.getMonth() + 1;
                    form_data.value.month_of_year = d.getMonth() + 1;
                    form_data.value.due_count_days = null;
                    form_data.value.due_day_of_month = dd.getDate();
                    form_data.value.due_month_of_period = dd.getMonth() + 1;
                    form_data.value.due_month_of_year = dd.getMonth() + 1;
                    form_data.value.due_date_type = "on_date";
                    break;
                case "custom":
                    //custom_view.value = true;
                    view_type.value = "custom";
                    if (form_data.value.type === "date") form_data.value.type = "monthly";
                    form_data.value.interval = 1;
                    form_data.value.day_of_month = d.getDate();
                    form_data.value.due_day_of_month = dd.getDate();
                    form_data.value.due_date_type = "on_date";
                    break;
            }
            form_data.value.interval_f = formatNumber(form_data.value.interval);
        };
        const due_date_type_change = function(data) {
            if (data === "plus_days") {
                form_data.value.due_calc_from = "start_date";
                form_data.value.due_calc_type = "calendar_days";
                if (form_data.value.due_count_days == null) {
                    form_data.value.due_count_days = form_data.value.type === "weekly" ? 0 : 1;
                    form_data.value.due_count_days_f = formatNumber(form_data.value.due_count_days);
                }
            } else if (data === "on_date") {
                if (!form_data.value.due_day_of_month) form_data.value.due_day_of_month = form_data.value.day_of_month;

                if (form_data.value.due_shift_to_workday === null) {
                    // fix task convert recurring 1st time
                    form_data.value.due_shift_to_workday = 0;
                }

                switch (form_data.value.type) {
                    case "quarterly":
                        if (!form_data.value.due_month_of_quarter)
                            form_data.value.due_month_of_quarter = form_data.value.month_of_quarter;
                        break;
                    case "yearly":
                        if (!form_data.value.due_month_of_year)
                            form_data.value.due_month_of_year = form_data.value.month_of_year;
                        break;
                }
            }
        };
        const time_field_changed = function(field, data) {
            form_data.value[field + "_error"] = null;

            if (!data) {
                form_data.value[field] = null;
                return;
            }

            let time = parseTime(data);
            if (time == null) {
                form_data.value[field + "_error"] = $t("Incorrect time");
                return;
            }

            form_data.value[field] = time;
        };
        const integer_field_changed = function(field, data) {
            form_data.value[field + "_error"] = null;

            if (!data) {
                form_data.value[field] = null;
                return;
            }

            let num_str = cleanNumber(data);
            if (isNaN(num_str)) {
                form_data.value[field + "_error"] = $t("Must be a number");
                form_data.value[field] = 0;
            } else {
                form_data.value[field] = parseInt(num_str);
            }
        };

        const formatOutput = (val) => {
            return formatRecurrence(val);
        };
        const focus = function() {
            if (!menu_open.value) menu_open.value = true;
        };
        const blur = function() {
            if (menu_open.value) menu_open.value = false;
        };

        const isStartDateActive = computed(() => {
            return activeField.value === 'start_date'
        })

        const isDueDateActive = computed(() => {
            return activeField.value === 'due_date'
        })

        const addRepeat = () => {
            repeatAdded.value = true
        }

        const canAddRepeat = computed(() => {
            if (props.task.id || props.task.virtual_id) {
                return false
            }

            if (props.task.has_due_date) {
                return false
            }

            if (props.task.recurrence_rule) {
                return false
            }

            if (repeatAdded.value) {
                return false
            }

            return true
        })

        const onRemoveRecurrence = () => {
            form_data.value.date = formatSysDate(new Date())
            form_data.value.due_date = formatSysDate(new Date())
            recurrence_changed('date')
            ctx.emit("change", get_clean_value());
            ctx.emit("tab_next");
            setTimeout(function() {
                menu_open.value = true;
            }, 0);
        }

        const hasErrors = computed(() => {
            return Object.keys({...form_data.value})
                .filter(x => x.includes('_error'))
                .map(x => Boolean(form_data.value[x]))
                .some(x => x)
        })

        const onChangeYearlyMonthOfYear = (value) => {
            form_data.value.month_of_year = value
            const leapYearWithSelectedMonth = new Date(2016, value - 1, 1)
            const daysInMonth = leapYearWithSelectedMonth.calcDaysInMonth()

            if (form_data.value.day_of_month > daysInMonth) {
                form_data.value.day_of_month = daysInMonth
            }
        }

        const onChangeYearlyDueMonthOfYear = (value) => {
            form_data.value.due_month_of_year = value
            const leapYearWithSelectedMonth = new Date(2016, value - 1, 1)
            const daysInMonth = leapYearWithSelectedMonth.calcDaysInMonth()

            if (form_data.value.due_day_of_month > daysInMonth) {
                form_data.value.due_day_of_month = daysInMonth
            }
        }

        const onSetTextStartDate = (value) => {
            typedDate.value = value

            const parsedDate = parseDate(value)
            if (!parsedDate) {
                return
            }

            dates.value[0] = formatSysDate(parsedDate)
            pickerDate.value = dates.value[0]

            textDatesChanged()
        }

        const onSetTextEndDate = (value) => {
            typedDate.value = value

            const parsedDate = parseDate(value)
            if (!parsedDate) {
                return
            }

            dates.value[1] = formatSysDate(parsedDate)
            pickerDate.value = dates.value[1]

            textDatesChanged()
        }

        const onFocusStartDate = (event) => {
            isStartInputActive.value = true;
            activeField.value = 'start_date';
            event.target.select();
            pickerDate.value = form_data.value.date
        }

        const onFocusEndDate = (event) => {
            isEndInputActive.value = true;
            activeField.value = 'due_date';
            event.target.select();
            pickerDate.value = form_data.value.due_date
        }

        return {
            menu_open,
            current_state,
            form_data,
            dates,
            simple_repeat_list,
            icon,
            show_time_fields,
            show_start_time_field,
            show_due_time_field,
            //custom_view,
            view_type,
            types,
            months_of_year,
            months_of_quarter,
            days_of_month,
            due_days_of_month,
            days_of_week,
            shifting,
            calc_form_list,
            due_calc_types,
            locale,
            date_menu_open,
            recurrence_enabled,
            coloring,
            focus,
            blur,
            dates_changed,
            recurrence_changed,
            time_field_changed,
            integer_field_changed,
            due_date_type_change,
            save,
            cancel,
            formatOutput,
            isStartDateActive,
            isDueDateActive,
            addRepeat,
            canAddRepeat,
            formatSysDate,
            parseSysDate,
            formatDate,
            onRemoveRecurrence,
            firstDayOfWeek,
            hasErrors,
            onChangeYearlyMonthOfYear,
            onChangeYearlyDueMonthOfYear,
            onSetTextStartDate,
            onSetTextEndDate,
            isStartInputActive,
            isEndInputActive,
            typedDate,
            endDateField,
            startDateField,
            pickerDate,
            activeField,
            onFocusStartDate,
            onFocusEndDate
        };
    }
};
</script>
<style scoped lang="scss">
.date-picker-highlighted.v-text-field {
    ::v-deep label {
        color: var(--v-primary-base) !important;
    }
}

.add-repeat-btn {
    &:hover {
        color: var(--v-primary-base) !important;
    }
}


</style>
